app.component('lirApp', {
    templateUrl: 'app/lirapp/lirApp.html',
    controller: function($rootScope, $window, localStorageAccess) {
        var $ctrl = this;
        var appData = localStorageAccess.getData( "app" );
        $ctrl.isIE = appData.isIE;
        $rootScope.$on("$routeChangeSuccess", function(){
            $window.scrollTo(0,0);
        })
    }
});
